import { useState, useRef } from 'react';
export function useSwipeToDelete(onDelete, { threshold = 80, behavior = 'flyOff' } = {}) {
    const [offset, setOffset] = useState(0);
    const [isSwiping, setIsSwiping] = useState(false);
    const offsetRef = useRef(0);
    const startXRef = useRef(0);
    const startYRef = useRef(0);
    const directionRef = useRef('none');
    const setOffsetBoth = (v) => {
        offsetRef.current = v;
        setOffset(v);
    };
    const handleTouchStart = (e) => {
        startXRef.current = e.touches[0].clientX;
        startYRef.current = e.touches[0].clientY;
        directionRef.current = 'none';
    };
    const handleTouchMove = (e) => {
        const deltaX = e.touches[0].clientX - startXRef.current;
        const deltaY = e.touches[0].clientY - startYRef.current;
        if (directionRef.current === 'none') {
            if (Math.abs(deltaX) > 8 || Math.abs(deltaY) > 8)
                directionRef.current = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';
        }
        if (directionRef.current === 'horizontal') {
            setIsSwiping(true);
            setOffsetBoth(Math.min(0, deltaX));
        }
    };
    const handleTouchEnd = () => {
        setIsSwiping(false);
        directionRef.current = 'none';
        if (offsetRef.current < -threshold) {
            if (navigator.vibrate)
                navigator.vibrate(50);
            if (behavior === 'flyOff') {
                setOffsetBoth(-window.innerWidth);
                setTimeout(onDelete, 280);
            }
            else {
                setOffsetBoth(0);
                onDelete();
            }
        }
        else {
            setOffsetBoth(0);
        }
    };
    return {
        offset,
        isSwiping,
        swipeProgress: Math.min(1, Math.abs(offset) / threshold),
        handlers: {
            onTouchStart: handleTouchStart,
            onTouchMove: handleTouchMove,
            onTouchEnd: handleTouchEnd,
        },
    };
}
